export default class TopXHelpers {
  public findLastGame = (games: Record<string, string>[]) => {
    if (!Array.isArray(games) || games.length === 0) return null;

    // Filter for settled games and sort by cutoff time descending (most recent first)
    const settledGames = games
      .filter((game) => game.status === "SETTLED")
      .sort(
        (a, b) =>
          new Date(b.predictionsCutoff).getTime() -
          new Date(a.predictionsCutoff).getTime()
      );

    if (settledGames.length > 0) {
      // There are settled games, return the most recent one
      return settledGames[0];
    }

    // We don't have any settled games, return the most recent past game
    const now = new Date();
    const pastGames = games
      .filter((game) => new Date(game.predictionsCutoff) < now)
      .sort(
        (a, b) =>
          new Date(b.predictionsCutoff).getTime() -
          new Date(a.predictionsCutoff).getTime()
      );

    return pastGames.length > 0 ? pastGames[0] : null;
  };

  public findNextGame = (games: Record<string, string>[]) => {
    if (!Array.isArray(games) || games.length === 0) return null;

    const currentGame = this.findCurrentGame(games);
    if (!currentGame) return null;

    // Sort by cutoff time ascending (earliest first)
    const sortedGames = [...games].sort(
      (a, b) =>
        new Date(a.predictionsCutoff).getTime() -
        new Date(b.predictionsCutoff).getTime()
    );

    const currentGameTime = new Date(currentGame.predictionsCutoff).getTime();

    // Find first game that has a cutoff time after current game
    return (
      sortedGames.find(
        (game) => new Date(game.predictionsCutoff).getTime() > currentGameTime
      ) || null
    );
  };

  public findCurrentGame = (games: Record<string, string>[]) => {
    if (!Array.isArray(games) || games.length === 0) return null;

    // First try to find a LIVE game
    const liveGame = games.find((game) => game.status === "LIVE");
    if (liveGame) return liveGame;

    // Then try to find an OPEN game
    const openGame = games.find((game) => game.status === "OPEN");
    if (openGame) return openGame;

    // If no live or open games, find the next upcoming game
    const now = new Date();
    const futureGames = games
      .filter((game) => new Date(game.predictionsCutoff) > now)
      .sort(
        (a, b) =>
          new Date(a.predictionsCutoff).getTime() -
          new Date(b.predictionsCutoff).getTime()
      );

    return futureGames[0] || null;
  };
}
